module.exports = __webpack_public_path__ + "static/media/paint-fill.77cdb063.svg";